export default __webpack_public_path__ + "assets/images/dce8a033e9885c6767b99cd8a0fcd295-error_sad_icon.svg";